import {
    Component,
    Input,
    OnInit,
    ViewChild
} from "@angular/core";
import { Router } from "@angular/router";
import { ProFunnelModel } from "../../../../model/builk/profunnel/profunnel.model";

// Service
import { ProFunnelService } from "../../../../service/api/builk/profunnel.service";
import { ProFunnelBadgeComponent } from "../profunnel-badge/profunnel-badge.component";

@Component({
    selector: "bo-builk-profunnel-button",
    templateUrl: "./profunnel-button.component.html",
    styleUrls: ["./profunnel-button.component.scss"]
})
export class ProFunnelButtonComponent implements OnInit {
    @ViewChild("proFunnelBadge")
    proFunnelBadge: ProFunnelBadgeComponent;
    @Input() rowData: ProFunnelModel;

    constructor(
        public router: Router,
        public proFunnelService: ProFunnelService
    ) {
    }
    
    proFunnel: ProFunnelModel = new ProFunnelModel();
    ngOnInit(): void {
    }

    openModal(id: number): void {
        this.proFunnelBadge.openModal(id);
    }
}
